// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"72":"thanks","171":"webinar"}[chunkId] + "-legacy." + {"72":"7dfa603e","171":"ef551875"}[chunkId] + ".js";
};